import React, { useState, useEffect } from 'react';
import heroBackground from '../../Assets/Images/Aboutus/rm378-06.jpg';
import {
  FaChalkboardTeacher,
  FaComments,
  FaCogs,
  FaProjectDiagram
} from "react-icons/fa";
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../../Assets/CSS/Contacts.scss';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import journeyBg from '../../Assets/Images/Aboutus/bg-3.jpg';
// import axios from 'axios';
import "../../Assets/CSS/Styles.scss";
import '../../Assets/CSS/Contacts.scss';
import { API_BASE_URL } from '../../config';

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-bootstrap';
import SuccessModal from "../../Componants/Models/SuccessModal";

const DemoPage = () => {

  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    budgetRange: '',
    designation: '',
    institutionName: '',
    projectDetails: '',
    updatesOptIn: false,
    formType: 'book-demo'
  });

  const [errors, setErrors] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    designation: '',
    institutionName: '',
    projectDetails: ''
  });

  const [success, setSuccessMessage] = useState('');
  const [error, setErrorMessage] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    isError: false
  });

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email) && (email.endsWith('.com') || email.endsWith('.org') || email.endsWith('.net') || email.endsWith('.edu') || email.endsWith('.in'));
  };

  const validateMobile = (mobile) => {
    const re = /^\d{10}$/;
    return re.test(mobile);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      fullName: '',
      emailAddress: '',
      mobileNumber: '',
      instituteType: '',
      designation: '',
      institutionName: '',
      projectDetails: ''
    };

    // Validate required fields
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
      valid = false;
    } else if (!/^[A-Za-z\s]{2,100}$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Full name should only contain letters and spaces (2–100 characters)";
      valid = false;
    }

    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = 'Email is required';
      valid = false;
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Please enter a valid email address (.com, .org, .net, .edu, .in)';
      valid = false;
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile number is required';
      valid = false;
    } else if (!validateMobile(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
      valid = false;
    }

    if (!formData.instituteType) {
      newErrors.instituteType = 'Institute type is required';
      valid = false;
    }

    if (!formData.designation.trim()) {
      newErrors.designation = 'Designation is required';
      valid = false;
    }

    if (!formData.institutionName.trim()) {
      newErrors.institutionName = 'Institution name is required';
      valid = false;
    }
    if (!formData.projectDetails.trim()) {
      newErrors.projectDetails = 'Project details are required';
      valid = false;
    } else if (wordCount > MAX_WORDS) {
      newErrors.projectDetails = `Project details cannot exceed ${MAX_WORDS} words`;
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setModalData({
          title: "Thank You for Reaching Out!",
          message: "Your message has been submitted successfully. Our team will contact you within 24 hours.",
          isError: false
        });

        setShowModal(true);

        setFormData({
          fullName: "",
          emailAddress: "",
          mobileNumber: "",
          instituteType: "",
          budgetRange: "",
          designation: "",
          institutionName: "",
          projectDetails: "",
          updatesOptIn: false,
          formType: 'book-demo'
        });
      } else {
        throw new Error("Failed to submit");
      }
    } catch (error) {
      setModalData({
        title: "Submission Failed ❌",
        message: "Something went wrong. Please try again later.",
        isError: true
      });

      setShowModal(true);
    }
  };


  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 50,
    });
  }, []);


  const features = [
    {
      icon: <FaChalkboardTeacher size={28} />,
      title: "Personalized Feature Walkthrough",
      description: "See firsthand how our platform's specific features address your institution's unique challenges and goals.",
    },
    {
      icon: <FaComments size={28} />,
      title: "Real-time Q&A Session",
      description: "Get immediate answers to all your questions from our product experts, ensuring clarity on every aspect.",
    },
    {
      icon: <FaCogs size={28} />,
      title: "Customized Use Case Scenarios",
      description: "Explore how our solution can be applied to your day-to-day operations with tailored examples.",
    },
    {
      icon: <FaProjectDiagram size={28} />,
      title: "Integration Possibilities & Roadmaps",
      description: "Understand our seamless integration capabilities and get a glimpse into future enhancements.",
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 640 },
      items: 2,
      partialVisibilityGutter: 30,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 20,
    },
  };
  const testimonials = [
    {
      quote: "This ERP changed how we operate. Super easy to manage!",
      author: "Dr. Shalini Verma",
      institution: "National Institute of Management",
    },
    {
      quote: "The support and onboarding were seamless. Highly recommend.",
      author: "Prof. Mahesh Rao",
      institution: "Global Tech University",
    },
    {
      quote: "We saved a lot of time on admin tasks after switching.",
      author: "Anita Desai",
      institution: "Greenwood High School",
    },
    {
      quote: "Incredible dashboard and student tracking tools.",
      author: "Rajeev Menon",
      institution: "Bright Future Academy",
    },
    {
      quote: "Reliable, intuitive, and well-supported ERP system.",
      author: "Sonal Gupta",
      institution: "Springfield Public College",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);


  // Sample FAQ data - replace with your actual data
  const faqs = [
    {
      question: "How long is the demo?",
      answer: "Our typical demo lasts about 30-45 minutes, tailored to your specific needs and questions.",
    },
    {
      question: "Is it really free?",
      answer: "Yes, our demo is completely free of charge and comes with no obligations.",
    },
    {
      question: "Do I need technical knowledge?",
      answer: "No, absolutely not! Our demos are designed for anyone, regardless of technical background.",
    },
    {
      question: "What happens after the demo?",
      answer: "After the demo, we’ll summarize key points and discuss next steps — no pressure at all.",
    },
  ];

  useEffect(() => {
    const stars = document.querySelectorAll(".clip-rect");

    stars.forEach((rect, i) => {
      let width = 0;
      setTimeout(() => {
        const interval = setInterval(() => {
          if (width >= 20) {
            clearInterval(interval);
          } else {
            width += 0.3; // Controls how smooth the fill is
            rect.setAttribute("width", width.toString());
          }
        }, 50); // Controls speed: increase for slower fill
      }, i * 1000); // Delay each star
    });
  }, []);

  const MAX_WORDS = 500;

  const wordCount = formData.projectDetails
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0).length;

  const percentage = Math.min((wordCount / MAX_WORDS) * 100, 100);

  const isWarning = wordCount >= 450 && wordCount <= MAX_WORDS;
  const isOverLimit = wordCount > MAX_WORDS;


  return (
    <div className="demo-page-container font-ui text-[#4B5563] bg-white mt60">
      {/* Hero Section */}
      <div className="demo-page-container font-ui text-[#4B5563] bg-white">

        {/* Hero Section */}
        <div
          className="relative h-[500px] md:h-[488px] bg-cover bg-center flex items-center justify-center p-4 text-white overflow-hidden "
        >
          <div
            className="absolute inset-0 bg-center bg-cover animate-slowZoom "
            style={{ backgroundImage: `url(${heroBackground})`, zIndex: 0 }}
          ></div>
          <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-1"></div>
          {/* Text Content */}
          <div className="relative z-5 text-center max-w-4xl mx-auto">
            <div className="mb-6">
              <div className="inline-flex items-center px-5 py-2 mb-4 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                Ready to Transform Your Institution?
              </div>
            </div>
            <h1 className="font-heading font-bold-500 text-white  lg:text-5xl text-center mb-6">
              See How Our ERP Can{" "}
              <br />
              <span className="text-[#FBBF24]  mt-4">
                Transform Your Institution
              </span>
            </h1>
            <p className="font-ui text-white text-md leading-6 mt-6 mb-8 p">
              Get a personalized walkthrough of Global Solutions cloud-based ERP
              suite. We'll show you how to digitize, automate, and analyze your
              operations — no tech knowledge required.
            </p>
            <p className="text-sm font-ui opacity-90">
              No spam. No pushy sales. Just value.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <section className="relative py-12 md:py-16 bg-gray-50">
        {/* Background Image - Desktop Only */}
        <div
          className="hidden md:block absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${journeyBg})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}
        >
          <div className="absolute inset-0 bg-white bg-opacity-70 z-0"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
          {/* Header Section */}
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading Headers mb-3">
              What You'll Get In Your Demo
            </h2>
            <p className="text-center text-[15px] !important; color: #374151 !important; font-ui mb-10">
              Experience a comprehensive walkthrough tailored specifically to your institution's needs.
            </p>
          </div>

          {/* Features Grid - Mobile layout similar to EduSuite360, Desktop keeps 4 cards */}
          <div className="grid grid-cols-1 gap-y-14 md:grid-cols-2 lg:grid-cols-4 md:gap-x-6">
            {features.map((f, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-400 rounded-xl shadow-md p-6 pt-14 md:pt-12 transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
              >
                {/* Floating Icon - Larger on mobile like EduSuite360 example */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <svg
                      className="h-6 w-6 md:h-6 md:w-6 text-amber-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {f.icon}
                    </svg>
                  </div>
                </div>

                {/* Content - Adjusted for mobile like EduSuite360 example */}
                <div className="mt-6 text-center">
                  <h3 className="text-[20px] md:text-lg font-bold text-gray-900 mb-2 md:mb-3">
                    {f.title}
                  </h3>
                  <p className="text-[15px] md:text-base text-gray-600 font-ui">
                    {f.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Form Section */}
      <section id="#book-demo-form" className="py-10 px-4 sm:px-6 lg:px-8 bg-[#F9FAFB]">
        <div className="text-center mt-2 md:mb-10">
          <h2 className="font-heading mb-3 text-[25px] font-bold text-gray-900">
            Book Your Free Demo
          </h2>
          <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
            Fill out the form below and we'll reach out within 24 hours
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 max-w-7xl mx-auto overflow-hidden mt-4 mb-4">
          {/* Left Visual Section */}
          <div className="hidden lg:flex bg-white px-8 items-center justify-center">
            <div className="max-w-xl w-full p-2 md:p-6">
              <div className="lottie-container">
                <DotLottieReact
                  src="https://lottie.host/4a27ccfc-8228-4920-9aaa-afbbbd79f01b/gLliwmBVSj.lottie"
                  loop
                  autoplay
                  className="w-[auto] h-[420px]"
                />
              </div>
            </div>
          </div>

          {/* Right Form Section */}
          <div className="bg-white px-4 sm:px-6 lg:px-8 flex justify-center">
            <div className="w-full max-w-xl p-4 md:p-6 border border-[#F59E0B] rounded-2xl">

              <form className="space-y-1">
                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        placeholder=" "
                      />
                      <label htmlFor="fullName">Full Name *</label>
                      {errors.fullName && <p className="form-error">{errors.fullName}</p>}
                    </div>
                  </Col>
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder=" "
                        value={formData.emailAddress}
                        onChange={handleChange}
                      />
                      <label htmlFor="emailAddress">Email Address *</label>
                      {errors.emailAddress && <p className="form-error">{errors.emailAddress}</p>}
                    </div>

                  </Col>
                </Row>

                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="tel"
                        id="mobileNumber"
                        placeholder=" "
                        inputMode="numeric"
                        pattern="[0-9]*"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                      />
                      <label htmlFor="mobileNumber">Mobile Number *</label>
                      {errors.mobileNumber && <p className="form-error">{errors.mobileNumber}</p>}
                    </div>
                  </Col>
                  <Col md>
                    {/* Institute Type */}
                    <div className="floating-group">
                      <select
                        id="instituteType"
                        name="instituteType"
                        placeholder=""
                        value={formData.instituteType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Institute Type</option>
                        <option value="Technical">Technical</option>
                        <option value="Medicalcollege">Medical</option>
                        <option value="Engineering">Engineering</option>
                        <option value="ArtsCommerceScience">Arts, Commerce, Science</option>
                        <option value="Corporate">Corporate</option>
                        <option value="Other">Other</option>
                      </select>

                      <label htmlFor="instituteType">Institute Type *</label>

                      {errors.instituteType && (
                        <p className="form-error">{errors.instituteType}</p>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="designation"
                        name='designation'
                        placeholder=" "
                        value={formData.designation}
                        onChange={handleChange}
                      />
                      <label htmlFor="designation">Role / Designation *</label>
                      {errors.designation && <p className="form-error">{errors.designation}</p>}
                    </div>

                  </Col>
                  <Col md>
                    <div className="floating-group">
                      <select
                        id="budgetRange"
                        name="budgetRange"
                        value={formData.budgetRange}
                        onChange={handleChange}
                      >
                        <option value="">Select budget range</option>
                        <option value="less-than-1L">Less than 1,00,000</option>
                        <option value="1L-5L">1,00,000 - 5,00,000</option>
                        <option value="5L-10L">5,00,000 - 10,00,000</option>
                        <option value="more-than-10L">More than 10,00,000</option>
                      </select>

                      <label htmlFor="budgetRange">Budget Range *</label>

                      {errors.budgetRange && (
                        <p className="form-error">{errors.budgetRange}</p>
                      )}
                    </div>
                  </Col>
                </Row>


                <Row className="g-2 mb-2">
                  <Col>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="institutionName"
                        name='institutionName'
                        placeholder=" "
                        value={formData.institutionName}
                        onChange={handleChange}
                      />
                      <label htmlFor="institutionName">Institution / Company Name *</label>
                      {errors.institutionName && <p className="form-error">{errors.institutionName}</p>}
                    </div>

                  </Col>
                </Row>

                <Row className="g-2 mb-3">
                  <Col>
                    <div className="floating-group premium-textarea">

                      <textarea
                        name="projectDetails"
                        id="projectDetails"
                        rows="5"
                        placeholder=" "
                        value={formData.projectDetails}
                        onChange={handleChange}
                        className={isOverLimit ? "limit-exceeded" : ""}
                      />

                      <label htmlFor="projectDetails">Project Details *</label>

                      {/* Premium Animated Counter */}
                      <div className="counter-wrapper">

                        <div className="counter-top">
                          <span className="helper-text">
                            Describe your project (max {MAX_WORDS} words)
                          </span>

                          <span
                            className={`word-count ${isOverLimit
                              ? "over"
                              : isWarning
                                ? "warning"
                                : ""
                              }`}
                          >
                            {wordCount} / {MAX_WORDS}
                          </span>
                        </div>

                        {/* Animated Progress Bar */}
                        <div className="progress-bar-container">
                          <div
                            className={`progress-bar ${isOverLimit
                              ? "over"
                              : isWarning
                                ? "warning"
                                : ""
                              }`}
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                      </div>

                      {errors.projectDetails && (
                        <p className="form-error">{errors.projectDetails}</p>
                      )}

                    </div>
                  </Col>
                </Row>


                <div className="flex items-start mb-2 mt-2">
                  <input
                    type="checkbox"
                    id="updatesOptIn"
                    name="updatesOptIn"
                    className="mt-1 custom-checkbox-advanced"
                    checked={formData.updatesOptIn}
                    onChange={(e) =>
                      setFormData({ ...formData, updatesOptIn: e.target.checked })
                    }
                  />
                  <label htmlFor="updatesOptIn" className="ml-2 text-sm mb-2">
                    I'd like to receive updates about new features, case studies, and educational technology insights.
                  </label>
                </div>

                <button type="button" className="contact-button font-ui "
                  onClick={handleSubmit}
                >
                  Send Message
                </button>

                <p className="contact-note">
                  We respect your privacy and will never share your information.
                </p>

              </form>
              {success && <p className="text-green-600 text-center mb-4">{success}</p>}
              {error && <p className="text-red-600 mb-4">{error}</p>}
            </div>
          </div>
        </div>
        <SuccessModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          title={modalData.title}
          message={modalData.message}
          isError={modalData.isError}
        />
      </section>

      {/* Testimonials */}
      <section className="py-16  px-4 mt-2 sm:px-6 lg:px-8 ">
        <h2 className=" Headers font-heading font-ui">Trusted by Leading Institutions</h2>
        <p className="text-center text-[15px] ;
                   color: #374151 !important; font-ui mb-10">See what our clients says out there transformation journey</p>
        <Carousel
          responsive={responsive}
          infinite
          autoPlay
          autoPlaySpeed={3500}
          transitionDuration={600}
          containerClass="max-w-7xl mx-auto"
          itemClass="px-4"
          arrows={false}
          showDots={false}
          pauseOnHover
          draggable={false}
          swipeable={false}
          keyBoardControl={false}
        >
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#FFF8F4] p-8 rounded-lg shadow-md border border-[#FEE2E2] h-full"
            >
              <div className="flex mb-4">
                {Array(5)
                  .fill()
                  .map((_, j) => (
                    <div key={j} className="relative w-6 h-6 mr-1">
                      {/* Empty star */}
                      <svg
                        className="absolute top-0 left-0 w-full h-full text-gray-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                      </svg>

                      {/* Filled star */}
                      <svg
                        className="absolute top-0 left-0 w-full h-full text-yellow-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <defs>
                          <clipPath id={`clip-star-${j}-${i}`}>
                            <rect x="0" y="0" width="20" height="20" />
                          </clipPath>
                        </defs>
                        <g clipPath={`url(#clip-star-${j}-${i})`}>
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.92 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
                        </g>
                      </svg>
                    </div>
                  ))}
              </div>

              <p className="text-sm text-[#374151] font-ui mb-7">"{t.quote}"</p>
              <p className="font-semibold font-ui text-[#111827]">{t.author}</p>
              <p className="text-sm font-ui text-[#6B7280]">{t.institution}</p>
            </div>
          ))}
        </Carousel>
      </section>


      {/* FAQs */}
      <section className="relative py-12 md:py-16 bg-gray-50"> {/* Fallback bg for mobile */}
        {/* Background - Desktop only */}
        <div className="hidden md:block absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${journeyBg})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white bg-opacity-70"></div>
        </div>

        <div className="relative z-10 px-4 sm:px-6">
          {/* Header */}
          <div className="text-center mb-8 md:mb-12 max-w-3xl mx-auto">
            <h2 className="Headers font-heading  mb-2">
              Frequently Asked Questions
            </h2>
            <p className="text-center text-[15px] !important; color: #374151 !important; font-ui mb-10">

              Get answers to common questions about our demo process
            </p>
          </div>

          {/* FAQ Items */}
          <div className="max-w-4xl mx-auto grid grid-cols-1 gap-3 md:gap-4 px-2 sm:px-0">
            {faqs.map((f, i) => (
              <div
                key={i}
                className="rounded-lg shadow-sm border border-amber-400 overflow-hidden bg-white"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="flex justify-between items-center w-full py-3 px-4 md:py-4 md:px-6 text-left hover:bg-amber-50 transition-colors"
                >
                  <span className="font-medium md:font-semibold text-gray-900 text-sm md:text-base lg:text-lg">
                    {f.question}
                  </span>
                  <svg
                    className={`w-5 h-5 text-amber-500 flex-shrink-0 transform transition-transform ${openIndex === i ? 'rotate-90' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {openIndex === i && (
                  <div className="px-4 pb-4 md:px-6 md:pb-6 pt-0 text-gray-600 text-sm md:text-base animate-fadeIn">
                    {f.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
export default DemoPage;
